import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                position="hover"
                theme="white"
                pc="https://websiteoss.ecoflow.com/upload/image/1721207059634/pc_Lightweight.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1721207084120/m_Lightweight.jpg"
                label={t('N_label')}
                title={t('N_title')}
                desc={t('N_desc')}
            />
        </div>
    );
}
